module.exports = __webpack_public_path__ + "static/media/dog_color_base.dc92ab10.png";